<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{{$t('health.nutritionalPlanTemplate.selector')}}</h2>
        <button class="close-btn" @click="$emit('close')">&times;</button>
      </div>

      <div class="modal-body">
        <div v-if="loading" class="loading-state">
          {{$t('health.nutritionalPlanTemplate.loading')}}
        </div>

        <div v-else-if="templates.length === 0" class="empty-state">
          {{$t('health.nutritionalPlanTemplate.noTemplate')}}
        </div>

        <div v-else class="template-list">
          <div
            v-for="template in templates"
            :key="template.id"
            class="template-item"
            @click="selectTemplate(template.id)"
          >
            <div class="template-info">
              <h3>{{ template.name }}</h3>
              <p v-if="template.description">{{ template.description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import templateApi from '../../api/template';

export default {
  name: 'TemplateListModal',
  data() {
    return {
      templates: [],
      loading: true
    };
  },
  async created() {
    try {
      this.templates = await templateApi.getTemplates(this);
    } catch (error) {
      console.error(this.$t('health.nutritionalPlanTemplate.errorLoading'), error);
    } finally {
      this.loading = false;
    }
  },
  methods: {
    selectTemplate(templateId) {
      this.$emit('input', templateId);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables";

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
}

.modal-content {
  background: white;
  border-radius: 8px;
  width: 90%;
  max-width: 500px;
  max-height: 80vh;
  display: flex;
  flex-direction: column;
}

.modal-header {
  padding: 1em;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;

  h2 {
    margin: 0;
    font-size: 1.2em;
  }
}

.close-btn {
  background: none;
  border: none;
  font-size: 1.5em;
  cursor: pointer;
  color: #666;
}

.modal-body {
  padding: 1em;
  overflow-y: auto;
}

.template-list {
  display: flex;
  flex-direction: column;
  gap: 0.8em;
}

.template-item {
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 1em;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    border-color: #F35647; // Tu color accent
    background-color: rgba(#F35647, 0.05);
  }

  h3 {
    margin: 0 0 0.2em 0;
    font-size: 1em;
  }

  p {
    margin: 0;
    font-size: 0.85em;
    color: #666;
  }
}

.loading-state, .empty-state {
  text-align: center;
  padding: 2em;
  color: #666;
}
</style>



// WEBPACK FOOTER //
// src/brand/health/components/template/TemplateListModal.vue